import { render, staticRenderFns } from "./after-payment.vue?vue&type=template&id=3d85572c&scoped=true&"
import script from "./after-payment.vue?vue&type=script&lang=js&"
export * from "./after-payment.vue?vue&type=script&lang=js&"
import style0 from "./after-payment.vue?vue&type=style&index=0&id=3d85572c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d85572c",
  null
  
)

export default component.exports